import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {getApplicationById} from '../../utils/services'
import usePapiEntities from '../shared/usePapiEntities'
import Placeholder from '../shared/Placeholder'
import {itemStyle, infoStyle} from '../shared/styles'
import {renderId, renderName, idCheck} from '../shared'
import ApplicationIcon from './ApplicationIcon'

const renderApplication = (application, showLink, hideId, size, multiLine) => (
    <div className="papi-item" style={itemStyle}>
        <ApplicationIcon size={size} />
        <div
            className="item-info"
            style={{...infoStyle, flexDirection: multiLine ? 'column' : 'row'}}
        >
            {renderName(application, 'applications', showLink, size)}
            {renderId(application.id, hideId, size, !multiLine)}
            {application.disabled ? <span> (not selectable)</span> : ''}
        </div>
    </div>
)

const FetchApplicationByIdAndRender = ({
    id,
    showLink,
    hideId,
    alwaysLoading,
    size,
    multiLine,
    tokenProvider,
    profileApiUrl
}) => {
    const {entity, setEntity, loading, setLoading} = usePapiEntities()

    useEffect(() => {
        const fetchApplication = async () => {
            if (alwaysLoading) {
                setLoading(true)
            } else if (id) {
                try {
                    setEntity(await getApplicationById(id, tokenProvider, profileApiUrl))
                    setLoading(false)
                } catch (error) {
                    console.error(error)
                    setLoading(false)
                }
            }
        }
        fetchApplication()
    }, [id, alwaysLoading])

    return loading ? <Placeholder /> : renderApplication(entity, showLink, hideId, size, multiLine)
}

const PapiApplication = ({
    id,
    application,
    showLink,
    hideId,
    alwaysLoading,
    size = 'medium',
    multiLine = false,
    tokenProvider,
    profileApiUrl
}) =>
    application ? (
        renderApplication(application, showLink, hideId, size, multiLine)
    ) : (
        <FetchApplicationByIdAndRender
            id={id}
            showLink={showLink}
            hideId={hideId}
            alwaysLoading={alwaysLoading}
            size={size}
            multiLine={multiLine}
            tokenProvider={tokenProvider}
            profileApiUrl={profileApiUrl}
        />
    )

PapiApplication.displayName = 'PapiApplication'

PapiApplication.propTypes = {
    application: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired
    }),
    id: idCheck('application'),
    tokenProvider: PropTypes.func,
    profileApiUrl: PropTypes.string
}

export default PapiApplication
